import { configureStore } from "@reduxjs/toolkit";
// import searchReducer from "./features/search/searchSlice";
import searchReducer from "./features/search/searchSlice1";
import exercisesReducer from "./features/exercises/exercisesSlice";
import newsletterReducer from "./features/newsletter/newsletterSlice";
import quizReducer from "./features/quiz/quizSlice";
import quizResultReducer from "./features/quiz-result/quizResultSlice";
import userReducer from "./features/user/userSlice";
import siteSettingsReducer from "./features/siteSettings/siteSettingsSlice";
import communityReducer from "./features/community/communitySlice";

export const store = configureStore({
  reducer: {
    search: searchReducer,
    exercises: exercisesReducer,
    newsletter: newsletterReducer,
    quiz: quizReducer,
    quizResult: quizResultReducer,
    user: userReducer,
    siteSettings: siteSettingsReducer,
    community: communityReducer,
  },
});
